module.exports = __webpack_public_path__ + "media/images/front/icon_check_02-448ca06eca332e581bf1555aed5f2fe7.svg";